<div>
  <form (ngSubmit)="onSubmit()" [formGroup]="form">
    <div class="formTable">
      @if (responseMessage && responseMessage !== '') {
        <div class="formRow" [ngStyle]="{ 'color': getMessageStyle() }">
          <strong>{{responseMessage}}</strong><br/>
        </div>
      }
      @for (field of fields; track field) {
        <div class="formRow">
          @if (field.controlType==='buttonSubmitAndClear') {
            <cp-form-field [field]="field" [form]="form" [submitAttempt]="formSubmitAttempt" (clearForm)="onClear()"></cp-form-field>
          }
          @if (field.controlType==='buttonAttachFile' || field.controlType==='buttonAttachImage') {
            <cp-form-field [field]="field" [form]="form" [submitAttempt]="formSubmitAttempt" (uploadingFile)="disableForm($event)"></cp-form-field>
          }
          @if (field.controlType!=='buttonSubmitAndClear' && field.controlType!=='buttonAttachFile' && field.controlType!=='buttonAttachImage' && field.controlType!=='msgFailure') {
            <cp-form-field
            [field]="field" [form]="form" [submitAttempt]="formSubmitAttempt"></cp-form-field>
          }
        </div>
      }
    </div>
  </form>
  @if (busy) {
    <img src="{{localImageLocation}}ajax-loader.gif" class="form-busy" alt="loading">
  }
  <cp-data-query-results [data]="dataQueryResults" (refreshPage)="onRefreshDataQuery()" (showModalResults)="onShowResultsInModal($event)"></cp-data-query-results>
  <cp-modal title="Confirmation" [blocking]="false" [modalId]="successModalId" (closed)="onModalClosed()">
    <div style="text-align: center">{{responseMessage}}</div>
  </cp-modal>
</div>
